import { useState } from "react";
import { Loader2, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const rules = (p) => [
  [p.length >= 8, "8 caractères minimum"],
  [/[A-Za-z]/.test(p), "Au moins une lettre"],
  [/\d/.test(p), "Au moins un chiffre"],
];

export default function PasswordForm({ onDone, submitLabel = "Enregistrer", currentLabel = "Mot de passe actuel" }) {
  const { refresh } = useAuth();
  const [cur, setCur] = useState("");
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const ok = rules(p1).every(([v]) => v) && p1 === p2 && cur;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: p1 });
      toast.success("Mot de passe modifié");
      await refresh();
      setCur("");
      setP1("");
      setP2("");
      onDone?.();
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  const type = show ? "text" : "password";
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="password-form">
      <Field label={currentLabel}><Input type={type} value={cur} onChange={(e) => setCur(e.target.value)} className="h-11 bg-white" autoComplete="current-password" data-testid="password-current-input" /></Field>
      <Field label="Nouveau mot de passe"><Input type={type} value={p1} onChange={(e) => setP1(e.target.value)} className="h-11 bg-white" autoComplete="new-password" data-testid="password-new-input" /></Field>
      <Field label="Confirmer le nouveau mot de passe"><Input type={type} value={p2} onChange={(e) => setP2(e.target.value)} className="h-11 bg-white" autoComplete="new-password" data-testid="password-confirm-input" /></Field>
      <ul className="text-xs space-y-1" data-testid="password-rules">
        {[...rules(p1), [p1 && p1 === p2, "Les deux saisies sont identiques"]].map(([v, l]) => (
          <li key={l} className={v ? "text-emerald-700" : "text-slate-400"}>{v ? "✓" : "○"} {l}</li>
        ))}
      </ul>
      <button type="button" onClick={() => setShow(!show)} className="text-xs font-semibold text-slate-500 inline-flex items-center gap-1" data-testid="password-toggle-visibility">
        {show ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />} {show ? "Masquer" : "Afficher"} les mots de passe
      </button>
      {err && <div className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-md px-3 py-2" data-testid="password-error">{err}</div>}
      <button type="submit" disabled={!ok || busy} data-testid="password-submit-button"
        className="w-full h-12 rounded-md bg-[#F49619] hover:bg-[#E0830B] text-[#0E2D43] font-bold flex items-center justify-center gap-2 transition-colors disabled:opacity-50">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : submitLabel}
      </button>
    </form>
  );
}
